// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --padding-bottom: 15%;
}

ion-spinner {
  margin: 10px 0;
}

h5 {
  font-weight: bold;
}

.resource-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 3px 0;
  margin: 0 20px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
}
.resource-item:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.resource-item .resource-icon-container {
  display: flex;
}
.resource-item .resource-icon-container .resource-icon {
  font-size: 36px;
  color: #ed143d;
}
.resource-item .resource-icon-container ion-avatar {
  margin: 0 auto;
}
.resource-item .resource-icon-container ion-avatar img {
  background-size: cover;
  border-radius: 15px;
  height: 45px;
  width: 45px;
}
.resource-item ion-label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.resource-item .resource-item-actions {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
}
.resource-item .resource-item-actions ion-badge {
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 10px;
}
.resource-item .resource-item-actions .close-icon-container {
  display: flex;
}
.resource-item .resource-item-actions .close-icon-container ion-icon {
  font-size: 24px;
  color: #ed143d;
}

ion-searchbar {
  --background: white;
  --icon-color: #ed143d;
  --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);
  padding: 5px 10px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}

.resources-wrapper {
  position: relative;
  overflow: auto;
  padding-bottom: 8px;
}

.resource-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: start;
  z-index: 20;
  padding: 15% 16px 0 16px;
}

.resource-overlay-message {
  max-width: 85%;
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  color: #1a1a1a;
  font-size: 15px;
  line-height: 1.4;
}

.resource-overlay-icon {
  font-size: 28px;
  color: #6c6c6c;
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/add-resource/add-resource.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AACE;EACE,iBAAA;AAEJ;;AACE;EAIE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AADJ;AATI;EACE,gCAAA;AAWN;AADI;EACE,aAAA;AAGN;AAFM;EACE,eAAA;EACA,cAAA;AAIR;AAFM;EACE,cAAA;AAIR;AAFQ;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAIV;AAAI;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAEN;AAAI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAEN;AADM;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AAGR;AADM;EACE,aAAA;AAGR;AAFQ;EACE,eAAA;EACA,cAAA;AAIV;;AAEE;EACE,mBAAA;EACA,qBAAA;EACA,8CAAA;EACA,iBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;AACJ;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;UAAA,0BAAA;EACA,qCAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AACF","sourcesContent":["ion-content {\n    --padding-bottom: 15%;\n  }\n  \n  ion-spinner {\n    margin: 10px 0;\n  }\n  h5 {\n    font-weight: bold;\n  }\n\n  .resource-item {\n    &:not(:last-child) {\n      border-bottom: 1px solid #e0e0e0;\n    }\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 3px 0;\n    margin: 0 20px;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 4px;\n    .resource-icon-container {\n      display: flex;\n      .resource-icon {\n        font-size: 36px;\n        color: #ed143d;\n        }\n      ion-avatar {\n        margin: 0 auto;\n\n        img {\n          background-size: cover;\n          border-radius: 15px;\n          height: 45px;\n          width: 45px;\n        }\n      }\n    }\n    ion-label {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n    .resource-item-actions {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      margin-left: auto;\n      ion-badge {\n        padding: 6px 8px;\n        border-radius: 6px;\n        font-size: 10px;\n      }\n      .close-icon-container {\n        display: flex;\n        ion-icon {\n          font-size: 24px;\n          color: #ed143d;\n        }\n      }\n    }\n  }\n  \n  ion-searchbar {\n    --background: white;\n    --icon-color: #ed143d;\n    --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);\n    padding: 5px 10px;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background: white;\n  }\n\n.resources-wrapper {\n  position: relative;\n  overflow: auto;\n  padding-bottom: 8px;\n}\n\n.resource-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(3px);\n  background: rgba(255, 255, 255, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  z-index: 20;\n  padding: 15% 16px 0 16px;\n}\n\n.resource-overlay-message {\n  max-width: 85%;\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  text-align: center;\n  color: #1a1a1a;\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n.resource-overlay-icon {\n  font-size: 28px;\n  color: #6c6c6c;\n  margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
